<template>
  <v-dialog
    width="700"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
    transition="slide-x-transition"
    v-model="getModalViewAccountBank"
  >
    <v-card dark class="expande-horizontal pb-3 wrap">
      <div class="expande-horizontal px-2 py-3">
        <v-btn dark @click="closeModalViewAccountBank" icon>
          <v-icon color="grey">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <span style="font-size: 17pt; white-space: nowrap; word-wrap: nowrap; width: 300px;" class="pr-2 fonte white--text">
          Conta Bancária
        </span>
        <div class="expande-horizontal"></div>
        <v-btn class="elevation-3" icon @click="closeModalViewAccountBank">
          <v-icon color="red darken-3">
            mdi-close
          </v-icon>
        </v-btn>
      </div>

      <div class="expande-horizontal wrap py-6 pb-0">
        <v-flex class="pb-3" xs12>
          <v-form ref="form">
            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Banco
              </span>
              <v-text-field
                v-model="getAccountBank.bank"
                :rules="[v=> !!v || 'preencha aqui']"
                dense
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>

            <!-- <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Código do banco
              </span>
              <v-text-field
                v-model="getAccountBank.bank_code"
                dense
                placeholder=""
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex> -->
            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Agência
              </span>
              <v-text-field
                v-model="getAccountBank.agency"
                dense
                placeholder=""
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>

            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Conta
              </span>
              <v-text-field
                v-model="getAccountBank.account"
                dense
                placeholder=""
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>

            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Tipo de conta
              </span>
              <v-select
                v-model="getAccountBank.account_type"
                dense
                :items="['Corrente', 'Poupanca']"
                placeholder=""
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-select>
            </v-flex>

            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Nome do titular
              </span>
              <v-text-field
                v-model="getAccountBank.target.name"
                :rules="[v=> !!v || 'preencha aqui']"
                dense
                placeholder="Nome completo"
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>
            
            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Cpf do titular
              </span>
              <v-text-field
                v-model="getAccountBank.target.cpf"
                :rules="[v=> !!v || 'preencha aqui']"
                dense
                placeholder="Cpf do titular"
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>

             <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Pix
              </span>
              <v-text-field
                v-model="getAccountBank.pix"
                :rules="[v=> !!v || 'preencha aqui']"
                dense
                placeholder=""
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>
            
            <v-flex class="px-2" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Outras informações
              </span>
              <v-textarea
                v-model="getAccountBank.info"
                outlined
                :color="$theme.primary"
              ></v-textarea>
            </v-flex>
            <v-flex class="px-2" xs12>
              <div class="expande-horizontal centraliza">
                <span class="fonte orange--text pa-6 text-center mx-3">A conta da chave deve bater com a conta da plataforma!</span>
              </div>
            </v-flex>
            
          </v-form>
        </v-flex>
      </div>

      <div class="expande-horizontal">
        <v-btn large dark @click="validate" tile block color="green">
          <span class="fonte"> Salvar </span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getModalViewAccountBank", "getAccountBank"])
  },
  methods: {
    ...mapActions(["createAccountBank", "updateAccountBank", "closeModalViewAccountBank"]),
    validate() {
      if (this.$refs.form.validate()) {
        if(this.getAccountBank._id) {
            this.updateAccountBank()
        } else {
            this.createAccountBank()
        }
      }
    }
  }
};
</script>
